module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.eot", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/fonts/15QGe_N.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/fonts/arvo-bold-webfont.eot
// module id = 60
// module chunks = 4